<header
  class="flex h-[70px] w-full items-center justify-between bg-linear-to-r from-[#081c2e] via-[#0a2540] to-[#0e3354] border-y border-white/10 px-6"
>
  <!-- LEFT / BRAND -->
  <div class="flex items-center gap-4">
    <a [routerLink]="['/']" class="inline-block">
      <img src="/midas_logo_only_dark.png" alt="MIDAS" class="h-[36px] w-[36px]" />
    </a>

    <div class="flex items-center gap-3 text-[20px] tracking-[0.32em]">
      <span class="font-light"> MIDAS </span>

      <span class="font-normal">|</span>

      <span class="bg-linear-to-r from-white to-[#88d3ee] bg-clip-text text-transparent font-bold"> MATRIX </span>
    </div>
  </div>

  <!-- RIGHT / ACTIONS -->
  @if (isAuthenticated()) {
  <div class="flex items-center gap-5">
    <!-- Hamburger (mobile) -->
    <button
      class="md:hidden text-slate-400 hover:text-white transition-colors"
      (click)="toggleSidebar()"
      [attr.aria-label]="'header.menu' | translate"
    >
      <span class="material-symbols-outlined text-[20px] leading-none"> menu </span>
    </button>

    <!-- Desktop -->
    <div class="hidden md:flex items-center gap-4">
      <button
        class="relative inline-flex h-8 w-8 items-center justify-center rounded-full bg-transparent transition-all duration-300"
        [attr.aria-label]="'header.notifications' | translate"
      >
        <span
          class="absolute inset-0 rounded-full p-[0.8px] bg-[conic-gradient(from_0deg,rgba(40,70,110,0.08)_0deg,rgba(40,70,110,0.06)_45deg,rgba(40,70,110,0.08)_90deg,rgba(255,255,255,0.45)_125deg,rgba(255,255,255,0.5)_135deg,rgba(255,255,255,0.45)_145deg,rgba(40,70,110,0.08)_180deg,rgba(40,70,110,0.06)_225deg,rgba(40,70,110,0.08)_270deg,rgba(255,255,255,0.45)_305deg,rgba(255,255,255,0.5)_315deg,rgba(255,255,255,0.45)_325deg,rgba(40,70,110,0.08)_360deg)]"
        >
          <span
            class="flex h-full w-full rounded-full bg-linear-to-b from-[#102036] to-[#203145]"
          ></span>
        </span>

        <!-- Bell Icon with Notification Badge -->
        <span class="relative z-10 flex items-center justify-center">
          <img src="/bell.png" alt="Notifications" class="h-5 w-5" />
          <span
            class="absolute -right-0.5 top-[2px] h-2 w-2 rounded-full bg-[#ef4444] shadow-[0_0_4px_rgba(239,68,68,0.6)]"
          ></span>
        </span>
      </button>
      <button
        class="relative inline-flex h-8 w-8 items-center justify-center rounded-full bg-transparent transition-all duration-300"
        [attr.aria-label]="'header.messages' | translate"
      >
        <span
          class="absolute inset-0 rounded-full p-[0.8px] bg-[conic-gradient(from_0deg,rgba(40,70,110,0.08)_0deg,rgba(40,70,110,0.06)_45deg,rgba(40,70,110,0.08)_90deg,rgba(255,255,255,0.45)_125deg,rgba(255,255,255,0.5)_135deg,rgba(255,255,255,0.45)_145deg,rgba(40,70,110,0.08)_180deg,rgba(40,70,110,0.06)_225deg,rgba(40,70,110,0.08)_270deg,rgba(255,255,255,0.45)_305deg,rgba(255,255,255,0.5)_315deg,rgba(255,255,255,0.45)_325deg,rgba(40,70,110,0.08)_360deg)]"
        >
          <span
            class="flex h-full w-full rounded-full bg-linear-to-b from-[#102036] to-[#203145]"
          ></span>
        </span>

        <img src="/mail.png" alt="Messages" class="h-5 w-5 relative z-10" />
      </button>

      <!-- Avatar trigger outside p-popover so it stays visible when popover is closed -->
      <div
        class="relative inline-flex h-8 w-8 items-center justify-center rounded-full bg-transparent cursor-pointer"
        (click)="toggleUserMenu($event, userMenuPanel)"
      >
        <span
          class="absolute inset-0 rounded-full p-[0.8px] bg-[conic-gradient(from_0deg,rgba(40,70,110,0.08)_0deg,rgba(40,70,110,0.06)_45deg,rgba(40,70,110,0.08)_90deg,rgba(255,255,255,0.45)_125deg,rgba(255,255,255,0.5)_135deg,rgba(255,255,255,0.45)_145deg,rgba(40,70,110,0.08)_180deg,rgba(40,70,110,0.06)_225deg,rgba(40,70,110,0.08)_270deg,rgba(255,255,255,0.45)_305deg,rgba(255,255,255,0.5)_315deg,rgba(255,255,255,0.45)_325deg,rgba(40,70,110,0.08)_360deg)]"
        >
          <span
            class="flex h-full w-full rounded-full bg-linear-to-b from-[#102036] to-[#203145]"
          ></span>
        </span>

        @if (profileImageUrl()) {
        <p-avatar
          [image]="getProfileImageUrl()"
          [unstyled]="true"
          [pt]="{
            root: 'h-6 w-6 overflow-hidden rounded-full relative z-10',
            image: 'h-full w-full object-cover'
          }"
        />
        } @else {
        <p-avatar
          [unstyled]="true"
          [pt]="{
            root: 'flex h-6 w-6 items-center justify-center rounded-full bg-transparent relative z-10',
            label: 'text-[11px] font-semibold text-white leading-none'
          }"
        >
          <span>{{ usernameInitials() }}</span>
        </p-avatar>
        }
      </div>

      <p-popover #userMenuPanel [dismissable]="true" [style]="{ width: 'min(320px, 90vw)' }"
        styleClass="!p-0 !bg-[#0a2238] !border !border-white/10 !rounded-md !shadow-lg">
        <ng-template pTemplate="content">
          <div class="flex flex-col">
            <!-- Menu items -->
            <div class="p-1">
              <button type="button"
                class="flex w-full items-center gap-2 rounded px-3 py-2 text-left text-sm text-slate-300 transition-colors hover:bg-white/5"
                (click)="onLogout(userMenuPanel)">
                <i class="pi pi-sign-out"></i>
                <span>{{ 'header.logout' | translate }}</span>
              </button>
            </div>
            <!-- Divider -->
            <div class="border-t border-white/10"></div>
            <!-- User menu footer (copyright + version) -->
            <div class="flex flex-col gap-1 px-3 py-3 text-center text-xs text-slate-400">
              <p class="text-slate-200">
                © {{ currentYear() }} MIDAS Healthcare Solutions, Inc.
              </p>
              <p>
                {{ 'header.version' | translate }}: {{ envLabel() }} {{ version() }} ({{ versionDate() }})
              </p>
            </div>
          </div>
        </ng-template>
      </p-popover>
    </div>
  </div>
  }
</header>

@if (isSidebarVisible()) {
<div class="fixed inset-0 bg-black/50 z-40 md:hidden" (click)="closeSidebar()"></div>

<div
  class="fixed top-0 right-0 h-full w-72 bg-linear-to-b from-[#081c2e] to-[#0a2540] border-l border-white/10 z-50 md:hidden"
>
  <!-- Close -->
  <div class="flex justify-end p-4 border-b border-white/10">
    <button class="text-slate-400 hover:text-white transition-colors" (click)="closeSidebar()" [attr.aria-label]="'header.close' | translate">
      <span class="material-symbols-outlined text-[20px] leading-none"> close </span>
    </button>
  </div>

  <!-- Profile -->
  <div class="flex flex-col items-center gap-3 p-6 border-b border-white/10">
    <div class="h-14 w-14 overflow-hidden rounded-full bg-slate-600">
      @if (profileImageUrl()) {
      <img [src]="getProfileImageUrl()" class="h-full w-full object-cover" />
      } @else {
      <div
        class="flex h-full w-full items-center justify-center text-[16px] font-semibold text-white"
      >
        {{ usernameInitials() }}
      </div>
      }
    </div>

    <div class="flex flex-col items-center leading-tight">
      <span class="text-[10px] tracking-[0.28em] text-slate-400"> {{ 'header.username' | translate }} </span>
      <span class="text-[15px] font-medium text-slate-100">
        {{ username() }}
      </span>
    </div>
  </div>

  <!-- Menu -->
  <div class="flex flex-1 flex-col gap-1 p-4">
    <button
      class="relative flex items-center gap-4 rounded-md p-3 text-slate-300 hover:bg-white/5 transition-colors"
    >
      <span class="material-symbols-outlined text-[22px] leading-none"> notifications </span>
      <span class="text-[14px]">{{ 'header.notifications' | translate }}</span>
      <span class="absolute right-4 top-4 h-2 w-2 rounded-full bg-red-500"></span>
    </button>

    <button
      class="flex items-center gap-4 rounded-md p-3 text-slate-300 hover:bg-white/5 transition-colors"
    >
      <span class="material-symbols-outlined text-[22px] leading-none"> mail </span>
      <span class="text-[14px]">{{ 'header.messages' | translate }}</span>
    </button>
<button class="flex items-center gap-4 rounded-md p-3 text-slate-300 hover:bg-white/5 transition-colors"
  (click)="onLogoutFromMobile()">
  <span class="material-symbols-outlined text-[22px] leading-none"> logout </span>
  <span class="text-[14px]">{{ 'header.logout' | translate }}</span>
</button>
</div>

<!-- User menu footer (copyright + version) on mobile -->
<div class="mt-auto border-t border-white/10 px-4 py-3 text-center text-xs text-slate-400">
  <p class="text-slate-200">© {{ currentYear() }} MIDAS Healthcare Solutions, Inc.</p>
  <p>{{ 'header.version' | translate }}: {{ envLabel() }} {{ version() }} ({{ versionDate() }})</p>
  </div>
</div>
}
